import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Modal, ModalBody } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { MaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../Utils/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { setEditSuccessMessage, setSuccessMessage } from '../../slices/toastMessage/action';
import { MenuItem } from "@mui/material";
import CommonModal from "../Utils/CommonModal";
import { QuotaForm } from './QuotaForm';
import { getAllQuota } from '../../slices/QuotaManagement/thunk';
import { deleteQuota } from '../../slices/QuotaManagement/DeleteQuota/thunk';
import { fetchAllOffers } from '../../slices/offer/thunk';
import { handleExportData } from '../Utils/ExportToCsv';
import { getQuotaByEvent } from '../../slices/QuotaManagement/GetQuota/thunk';
import { MidSessionForm } from './MidSessionForm';
import { getMidSession } from '../../slices/MidSession/thunk';
import { deleteMidSession } from '../../slices/MidSession/DeleteMidSession/thunk';
import { useColumnSettings } from '../Utils/useColumnSettings';
import { formatCellValue, formatDateForDisplay, hasPermission } from '../Utils/UtilityFunctions';

function MidSessionConfigurationListing() {
    const [loading, setLoading] = useState(false);
    const [messageForPopUp, setMessageForPopUp] = useState('');
    const [eventType, setEventType] = useState("")
    const [selectedQuota, setSelectedQuota] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage);
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const uom = useSelector((state) => state.Uom.uom);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );

    const [modalOpen, setModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewMidSessionData, setViewMidSessionData] = useState(null);

    const toggleModals = () => {
        setModalOpen(prev => !prev);
    };

    const toggleViewModal = () => {
        setViewModalOpen(prev => !prev);
    };

    const midsessionPermission = hasPermission(permissionsMap, "charging", "midsessioncdr")
    const viewPermission=hasPermission(permissionsMap, "miscellaneous", "view")
    const columns = [

        {
            accessorKey: 'triggerConfigId',
            header: 'Trigger Configuration ID',
            Cell: ({ cell }) => formatCellValue(cell.getValue()),
        },
        {
            accessorKey: 'usageEventType',
            header: 'Usage Event Type',
            Cell: ({ cell }) => formatCellValue(cell.getValue()),
        },

    ];
    useEffect(() => {
        dispatch(getMidSession(setLoading))
        dispatch(fetchAllOffers(setLoading));
    }, [dispatch]);

    const quota = useSelector((state) => state.getAllMidSession.midsession || []);
    const offers = useSelector((state) => state.Offer?.offer || []);
    const quotaByEventType = useSelector((state) => state.GetQuotaByEvent.QuotaByEvent);
    useEffect(() => {
        if (isEditMode && quotaByEventType) {
            setSelectedQuota(prev => ({ ...prev, ...quotaByEventType }));
        }
    }, [quotaByEventType]);
    const extractedData = Array.from(
        new Map(
            offers.flatMap(offer =>
                offer.usageRatePlan?.map(({ eventType, uomName }) => ({
                    eventType,
                    uom: uomName
                })) || []
            ).map(obj => [`${obj.eventType}-${obj.uom}`, obj])
        ).values()
    );
    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Mid Session Configuration Created Successfully`);
            dispatch(setSuccessMessage(false));
        }
        if (showEditSuccessMessage) {
            toast.success(`Mid Session Configuration Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch]);

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setEventType(id);
            setModal(!modal);
        }
        document.body.style.overflow = 'auto';
    };
    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar,
        CustomViewModal

    } = useColumnSettings('quota', columns);
    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white'>
                <Container fluid>
                    <BreadCrumb title="Mid Session Configuration" pageTitle="Charging" />
                    <ToastContainer position='top-center' />
                    <Row>
                        <Col >
                            <div className="listingjs-table" id="customerList">

                                <CardBody>
                                    <Row className="mb-3 mt-1 table-responsive">
                                        {loading && (<Loader />)}
                                        {uom ?
                                            <>
                                                <MaterialReactTable
                                                    icons={{
                                                        DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                    }}

                                                    positionToolbarAlertBanner='none'
                                                    renderTopToolbarCustomActions={({ table }) => (
                                                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100 mt-n1">
                                                            <h5 className="rv-page-title">Mid Session List</h5>

                                                            <div className="d-flex align-items-center">
                                                                <div className="d-flex ">
                                                                    {midsessionPermission && midsessionPermission?.has("export") &&
                                                                        <Button
                                                                            color="secondary"
                                                                            className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                                                            onClick={() => { handleExportData(quota) }}
                                                                        >
                                                                            <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                                            <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                                                        </Button>}
                                                                    {midsessionPermission && midsessionPermission?.has("create") &&
                                                                        <Button
                                                                            color="secondary"
                                                                            className="btn-label rv-primary-btn me-2 rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                                                            onClick={() => {
                                                                                setModalOpen(true);
                                                                                setIsEditMode(false);
                                                                            }}
                                                                        >
                                                                            <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                                                            <span className="ps-2 ms-2 me-1">Add Mid Session</span>
                                                                        </Button>
                                                                    }

                                                                </div>
                                                                {viewPermission && viewPermission?.has("view") &&
                                                                <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                                                                    <i className="ri-settings-2-line fs-4"></i>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    )}
                                                    // renderTopToolbarCustomActions={({ table }) => (
                                                    //     <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                    //         <div className="d-flex flex-column flex-md-row">
                                                    //             <Button color="secondary" className="btn-label me-2 mb-2 mb-md-0" onClick={() => { handleExportData(quota) }}>
                                                    //                 <i className="ri-upload-line label-icon align-middle fs-16 me-2"></i> Export Data
                                                    //             </Button>
                                                    //             {uomPermission && uomPermission.permissionList.includes('create') &&
                                                    //                 <Button
                                                    //                     color="secondary"
                                                    //                     className="btn-label me-2 mb-2 mb-md-0"
                                                    //                     onClick={() => {
                                                    //                         setModalOpen(true);
                                                    //                         setIsEditMode(false);
                                                    //                     }}
                                                    //                 >
                                                    //                     <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i> Add Mid Session
                                                    //                 </Button>}
                                                    //         </div>
                                                    //     </div>
                                                    // )}
                                                    initialState={{
                                                        columnOrder: [
                                                            'mrt-row-actions',
                                                            'Name',
                                                            'Value Type'
                                                        ]
                                                    }}
                                                    columns={columns}
                                                    data={quota}
                                                    enableColumnActions={true}
                                                    enableRowActions={true}
                                                    displayColumnDefOptions={{
                                                        'mrt-row-actions': {
                                                            header: '',
                                                            enableHiding: false,
                                                        },
                                                    }}
                                                    muiTableContainerProps={{
                                                        sx: {
                                                            border: '1px solid #e9ebec',
                                                        }
                                                    }}
                                                    defaultColumn={{
                                                        minSize: 1,
                                                        maxSize: 9001,
                                                        muiTableBodyCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        },
                                                        muiTableHeadCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        }
                                                    }}
                                                    layoutMode='grid'
                                                    renderRowActionMenuItems={({ closeMenu, row }) => [
                                                        <MenuItem className='row-options' key={`${row.index}.1`} onClick={() => {
                                                            setViewMidSessionData(row.original);
                                                            setViewModalOpen(true);
                                                            closeMenu();
                                                        }}><i className="ri-eye-line me-2" /> View</MenuItem>,
                                                        <MenuItem className='row-options' key={`${row.index}.2`} onClick={() => {
                                                            setIsEditMode(true);
                                                            setSelectedQuota(row.original);
                                                            setModalOpen(true);
                                                            // dispatch(getQuotaByEvent(setLoading, row.original.usageEventType));
                                                            closeMenu();
                                                        }}><i className="bx bxs-edit me-2" /> Edit</MenuItem>,
                                                        <MenuItem className='row-options'
                                                            key="delete"
                                                            onClick={() => {
                                                                setMessageForPopUp(`Are you sure you want to delete "${row.original.usageEventType}"?`)
                                                                toggleModal(row, "single");
                                                                closeMenu();
                                                            }}
                                                        >
                                                            <i className="ri ri-delete-bin-5-line me-2" /> Delete
                                                        </MenuItem>,
                                                    ]}
                                                    enableDensityToggle={false}
                                                />
                                            </>
                                            : null
                                        }
                                    </Row>
                                </CardBody>

                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
                <CommonModal modalHeader='Delete Mid Session' messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(eventType, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }
                } open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Yes, Delete It"} modalAction={() => {
                    if (modal) {
                        dispatch(deleteMidSession(eventType.original.usageEventType, setLoading, navigate));
                        toggleModal(eventType, "single");
                    }
                }} />

                <Modal isOpen={modalOpen} toggle={toggleModals} centered size="md" className="custom-modal">
                    <button type="button" className="close-button-currency mt-n1" onClick={toggleModals}>
                        &times;
                    </button>
                    <h5 className="text-center w-100 mt-0 fw-semibold py-3  rv-breadcrumb-border ">
                        {isEditMode ? "Edit Mid Session" : "Add Mid Session "}
                    </h5>
                    <ModalBody>
                        <MidSessionForm extractedData={extractedData} toggleModals={toggleModals} setModalOpen={setModalOpen} initialData={isEditMode ? selectedQuota : null} isEditMode={isEditMode} />
                    </ModalBody>
                </Modal>

                {/* View Modal */}
                <Modal isOpen={viewModalOpen} toggle={toggleViewModal} centered size="md" className="custom-modal">
                    <button type="button" className="close-button-currency mt-n1" onClick={toggleViewModal}>
                        &times;
                    </button>
                    <h5 className="text-center w-100 mt-0 fw-semibold py-3 rv-breadcrumb-border">
                        View Mid Session
                    </h5>
                    <ModalBody>
                        {viewMidSessionData && (
                            <div className="view-mid-session-container px-2">
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <h6 className="mb-2 view-text-color text-black fw-bold">Trigger Configuration ID</h6>
                                        <p className="mb-0 text-black fs-14">{viewMidSessionData.triggerConfigId}</p>
                                    </Col>
                                    <Col md={6}>
                                        <h6 className="mb-2 view-text-color text-black fw-bold">Usage Event Type</h6>
                                        <p className="mb-0 text-black fs-14">{viewMidSessionData.usageEventType}</p>
                                    </Col>
                                </Row>

                                {/* Trigger Conditions Section */}
                                <div>
                                    <h6 className="mb-3 text-black fw-bol fs-16">Trigger Conditions</h6>
                                    {viewMidSessionData.triggerConditions && (
                                        <div >

                                            <Row>
                                                {/* Trigger Conditions */}
                                                {viewMidSessionData.triggerConditions && (
                                                    <>
                                                        {/* Time Interval */}
                                                        {viewMidSessionData.triggerConditions.timeInterval && (
                                                            <Col lg={4}>
                                                                <div className="mb-3">
                                                                    <h6 className="mb-2 text-black fw-semibold">Time Interval</h6>


                                                                    <h6 className="mb-1 view-text-color text-black fw-bold">Interval Unit</h6>
                                                                    <p className="mb-2 text-black fs-14">{viewMidSessionData.triggerConditions.timeInterval.intervalUnitInSeconds}</p>


                                                                </div>
                                                            </Col>
                                                        )}

                                                        {/* Volume Threshold */}
                                                        {viewMidSessionData.triggerConditions.volumeThreshold && (
                                                            <Col lg={4}>
                                                                <div className="mb-3">
                                                                    <h6 className="mb-2 text-black fw-semibold">Volume Threshold</h6>


                                                                    <h6 className="mb-1 view-text-color text-black fw-bold">Threshold Unit</h6>
                                                                    <p className="mb-1 text-black fs-14">{viewMidSessionData.triggerConditions.volumeThreshold.thresholdUnit}</p>


                                                                </div>
                                                            </Col>
                                                        )}

                                                        {/* Balance Threshold */}
                                                        {viewMidSessionData.triggerConditions.balanceThreshold && (
                                                            <Col lg={4}>
                                                                <div className="mb-4">
                                                                    <h6 className="mb-2 view-text-color text-black fw-semibold">Balance Threshold</h6>


                                                                    <h6 className="mb-1 view-text-color text-black fw-bold">Threshold Amount</h6>
                                                                    <p className="mb-2 text-black fs-14">{viewMidSessionData.triggerConditions.balanceThreshold.thresholdAmount}</p>


                                                                </div>
                                                            </Col>
                                                        )}
                                                    </>
                                                )}
                                            </Row>

                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </ModalBody>

                </Modal>
            </div>
        </React.Fragment>
    );
}

export default MidSessionConfigurationListing;